import axios from 'axios';
import * as types from './ApparelEditor.types';
import * as selectors from './ApparelEditor.selectors';
import { empty, showNotification } from './../../utils';
import * as loginActions from './../Login/Login.actions';
import * as loginSelectors from './../Login/Login.selectors';

const apiUrl = process.env.REACT_APP_API_URL;

export const fetchApparelItem = (id, departmentId) => (dispatch) => {
    dispatch({ type: types.FETCH_APPAREL_ITEM, payload: null });
    axios.get(apiUrl + '/uthealth-apparel-items/' + id + '?department-id=' + departmentId,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.FETCH_APPAREL_ITEM_SUCCESS, payload: response.data });

            if (!empty(response.data.logos_options_json)) {
                let hasUtp = false;
                const logos = JSON.parse(response.data.logos_options_json);
                for (let i = 0; i < logos.length; i++) {
                    if (parseInt(logos[i].value) === 1) {
                        hasUtp = true;
                        break;
                    }
                }

                if (hasUtp) {
                    dispatch(setLogo(1));
                } else {
                    dispatch(setLogo(2));
                }
            }
        })
        .catch((error) => {
            dispatch({ type: types.FETCH_APPAREL_ITEM_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const addToCart = (orderType = 1, history, type = 1) => (dispatch, getState) => {
    const user = loginSelectors.getUser(getState());
    const cxmlData = loginSelectors.getCxmlData(getState());
    const templateCode = selectors.getTemplateCode(getState());
    const quantity = selectors.getQuantity(getState());
    const size = selectors.getSize(getState());
    const logo = selectors.getLogo(getState());
    const persons = selectors.getPersons(getState());
    const department = selectors.getDepartment(getState());
    const managerClinicName = selectors.getManagerClinicName(getState());
    const managerName = selectors.getManagerName(getState());
    const managerEmail = selectors.getManagerEmail(getState());
    const managerAddress = selectors.getManagerAddress(getState());
    const managerCity = selectors.getManagerCity(getState());
    const managerState = selectors.getManagerState(getState());
    const managerZip = selectors.getManagerZip(getState());
    const managerPhone = selectors.getManagerPhone(getState());
    const personalizationEnabled = selectors.getPersonalizationEnabled(getState());
    const action = selectors.getAction(getState());
    const variables = selectors.getVariables(getState());

    var newPersons = [...persons];
    for (let i = 0; i < newPersons.length; i++) {
        if (parseInt(newPersons[i].isUthHouston) === 1) {
            newPersons[i].logo = 2;
        }
    }

    var formData = new FormData();
    formData.append('userId', user.id);
    formData.append('orderType', orderType);
    formData.append('productType', 3);
    formData.append('quantity', quantity);
    formData.append('size', size);
    formData.append('logo', logo);
    formData.append('templateCode', templateCode);
    formData.append('departmentId', department.id);
    formData.append('persons', JSON.stringify(newPersons));
    formData.append('personalizationEnabled', personalizationEnabled ? 1 : 0);

    formData.append('managerClinicName', managerClinicName);
    formData.append('managerName', managerName);
    formData.append('managerEmail', managerEmail);
    formData.append('managerAddress', managerAddress);
    formData.append('managerCity', managerCity);
    formData.append('managerState', managerState);
    formData.append('managerZip', managerZip);
    formData.append('managerPhone', managerPhone);

    // UTH Unisex
    formData.append('uth_unisex_position_full_front', variables.uth_unisex_position_full_front);
    formData.append('uth_unisex_position_full_back', variables.uth_unisex_position_full_back);
    formData.append('uth_unisex_position_left_chest', variables.uth_unisex_position_left_chest);
    formData.append('uth_unisex_position_right_chest', variables.uth_unisex_position_right_chest);
    formData.append('uth_unisex_position_sleeve', variables.uth_unisex_position_sleeve);
    formData.append('uth_unisex_position_other', variables.uth_unisex_position_other);
    formData.append('uth_unisex_position_other_text', variables.uth_unisex_position_other_text);
    formData.append('uth_unisex_ink_university_orange', variables.uth_unisex_ink_university_orange);
    formData.append('uth_unisex_ink_university_blue', variables.uth_unisex_ink_university_blue);
    formData.append('uth_unisex_ink_university_grey', variables.uth_unisex_ink_university_grey);
    formData.append('uth_unisex_ink_university_black_white', variables.uth_unisex_ink_university_black_white);
    formData.append('uth_unisex_ink_gulf_blue', variables.uth_unisex_ink_gulf_blue);
    formData.append('uth_unisex_ink_mustard', variables.uth_unisex_ink_mustard);
    formData.append('uth_unisex_ink_dark_sage', variables.uth_unisex_ink_dark_sage);
    formData.append('uth_unisex_ink_dusty_lavender', variables.uth_unisex_ink_dusty_lavender);
    formData.append('uth_unisex_shirt_color', variables.uth_unisex_shirt_color);
    formData.append('uth_unisex_size_small', variables.uth_unisex_size_small);
    formData.append('uth_unisex_size_medium', variables.uth_unisex_size_medium);
    formData.append('uth_unisex_size_large', variables.uth_unisex_size_large);
    formData.append('uth_unisex_size_xl', variables.uth_unisex_size_xl);
    formData.append('uth_unisex_size_2xl', variables.uth_unisex_size_2xl);
    formData.append('uth_unisex_size_3xl', variables.uth_unisex_size_3xl);
    formData.append('uth_unisex_size_small_qty', variables.uth_unisex_size_small_qty);
    formData.append('uth_unisex_size_medium_qty', variables.uth_unisex_size_medium_qty);
    formData.append('uth_unisex_size_large_qty', variables.uth_unisex_size_large_qty);
    formData.append('uth_unisex_size_xl_qty', variables.uth_unisex_size_xl_qty);
    formData.append('uth_unisex_size_2xl_qty', variables.uth_unisex_size_2xl_qty);
    formData.append('uth_unisex_size_3xl_qty', variables.uth_unisex_size_3xl_qty);
    for (let i = 1; i <= variables.uth_unisex_files.length; i++) {
        formData.append('uth_unisex_file' + i, variables.uth_unisex_files[i - 1]);
    }
    formData.append('uth_unisex_files_length', variables.uth_unisex_files.length);

    formData.append('cxml_id', cxmlData.id);
    formData.append('cxml_buyer_cookie', cxmlData.buyer_cookie);
    formData.append('cxml_browser_form_post', cxmlData.browser_form_post);
    formData.append('cxml_supplier_domain', cxmlData.supplier_domain);
    formData.append('cxml_supplier_id', cxmlData.supplier_id);
    formData.append('cxml_buyer_domain', cxmlData.buyer_domain);
    formData.append('cxml_buyer_id', cxmlData.buyer_id);

    formData.append('action', action);
    formData.append('type', type);
    if (action === 'edit') {
        formData.append('editId', localStorage.getItem('id'));
    }

    dispatch({ type: types.ADD_TO_CART, payload: type });
    axios.post(apiUrl + '/uthealth-shopping-cart-items', formData,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.ADD_TO_CART_SUCCESS, payload: response.data });

            if (parseInt(type) === 1) {
                showNotification('Success', 'The item was added to your cart', 'success');
            } else if (parseInt(type) === 2) {
                showNotification('Success', 'The item has been saved into your shopping cart for future edit', 'success', 6000);
            }
            history.push('/shopping-cart');
        })
        .catch((error) => {
            dispatch({ type: types.ADD_TO_CART_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else if (error.response && error.response.status === 409) {
                showNotification('Sold out', 'This item has been sold out, please refresh your page to see the most up to date inventory', 'info');
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const loadVariables = () => (dispatch, getState) => {
    if (localStorage.getItem('variables') != null) {
        const productType = localStorage.getItem('productType');
        const variables = JSON.parse(localStorage.getItem('variables'));
        const apparelItem = JSON.parse(localStorage.getItem('apparelItem'));
        const department = JSON.parse(localStorage.getItem('department'));

        if (parseInt(productType) === 3) {     // Apparel
            dispatch(setApparelItem(apparelItem));
            dispatch(setDepartment(department));

            const sizesJson = JSON.parse(apparelItem.sizes_options_json);
            const logosJson = JSON.parse(apparelItem.sizes_options_json);

            let embroiderySet = false;
            for (let i = 0; i < variables.personsParsed.length; i++) {
                const person = variables.persons[i];
                const personParsed = variables.personsParsed[i];
                dispatch(addPerson(sizesJson, logosJson));
                dispatch(setPersonField(i, 'name', personParsed.name));

                if (parseInt(personParsed.logo) === 2 && parseInt(personParsed.isUthHouston) === 1) {
                    dispatch(setPersonField(i, 'logo', 3));
                } else {
                    dispatch(setPersonField(i, 'logo', personParsed.logo));
                }

                if (personParsed.isUthHouston !== undefined && personParsed.isUthHouston != null) {
                    dispatch(setPersonField(i, 'isUthHouston', personParsed.isUthHouston));
                }

                for (let j = 0; j < person.quantities.length; j++) {
                    const quantity = person.quantities[j];
                    dispatch(setPersonQuantity(i, j, quantity));
                }

                if (personParsed.embroideryFirstLine && personParsed.embroideryFirstLine !== '') {
                    if (!embroiderySet) {
                        dispatch(setPersonalizationEnabled(true));
                    }

                    dispatch(setPersonField(i, 'embroideryFirstLine', personParsed.embroideryFirstLine));
                    dispatch(setPersonField(i, 'embroiderySecondLine', personParsed.embroiderySecondLine));
                    dispatch(setPersonField(i, 'embroideryEmail', personParsed.embroideryEmail));
                }
            }

            if (variables.managerName && variables.managerName !== '') {
                dispatch(setManagerClinicName(variables.managerClinicName));
                dispatch(setManagerName(variables.managerName));
                dispatch(setManagerEmail(variables.managerEmail));
                dispatch(setManagerAddress(variables.managerAddress));
                dispatch(setManagerCity(variables.managerCity));
                dispatch(setManagerState(variables.managerState));
                dispatch(setManagerZip(variables.managerZip));
                dispatch(setManagerPhone(variables.managerPhone));
            }
        }
    }
}

export const checkShirts = (uthId, index) => (dispatch) => {
    dispatch({ type: types.CHECK_SHIRTS, payload: index });
    axios.get(apiUrl + '/uthealth-apparel-item/check-shirts?uthId=' + uthId,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.CHECK_SHIRTS_SUCCESS, payload: { index, shirts: response.data } });
        })
        .catch((error) => {
            dispatch({ type: types.CHECK_SHIRTS_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const addFavorite = (history) => (dispatch, getState) => {
    const user = loginSelectors.getUser(getState());
    const cxmlData = loginSelectors.getCxmlData(getState());
    const templateCode = selectors.getTemplateCode(getState());

    var formData = new FormData();
    formData.append('userId', user.id);
    formData.append('productType', 3);
    formData.append('templateCode', templateCode);
    formData.append('pathname', history.location.pathname);

    formData.append('cxml_id', cxmlData.id);
    formData.append('cxml_buyer_cookie', cxmlData.buyer_cookie);
    formData.append('cxml_browser_form_post', cxmlData.browser_form_post);
    formData.append('cxml_supplier_domain', cxmlData.supplier_domain);
    formData.append('cxml_supplier_id', cxmlData.supplier_id);
    formData.append('cxml_buyer_domain', cxmlData.buyer_domain);
    formData.append('cxml_buyer_id', cxmlData.buyer_id);

    dispatch({ type: types.ADD_FAVORITE, payload: null });
    axios.post(apiUrl + '/uthealth-favorite/add-favorite', formData,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.ADD_FAVORITE_SUCCESS, payload: response.data });

            if (parseInt(response.data.type) === 1) {
                showNotification('Success', 'The item has been added to your Favorites', 'success');
            } else {
                showNotification('Success', 'The item has been removed from your Favorites', 'success');
            }
        })
        .catch((error) => {
            dispatch({ type: types.ADD_FAVORITE_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const checkFavorite = (templateCode) => (dispatch, getState) => {
    const user = loginSelectors.getUser(getState());
    const cxmlData = loginSelectors.getCxmlData(getState());

    var formData = new FormData();
    formData.append('userId', user.id);
    formData.append('productType', 3);
    formData.append('templateCode', templateCode);

    formData.append('cxml_id', cxmlData.id);
    formData.append('cxml_buyer_cookie', cxmlData.buyer_cookie);
    formData.append('cxml_browser_form_post', cxmlData.browser_form_post);
    formData.append('cxml_supplier_domain', cxmlData.supplier_domain);
    formData.append('cxml_supplier_id', cxmlData.supplier_id);
    formData.append('cxml_buyer_domain', cxmlData.buyer_domain);
    formData.append('cxml_buyer_id', cxmlData.buyer_id);

    dispatch({ type: types.CHECK_FAVORITE, payload: null });
    axios.post(apiUrl + '/uthealth-favorite/check-favorite', formData,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.CHECK_FAVORITE_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            dispatch({ type: types.CHECK_FAVORITE_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const setTemplateCode = (value) => dispatch => {
    dispatch({
        type: types.SET_TEMPLATE_CODE,
        payload: value
    });
}

export const setQuantity = (value) => dispatch => {
    dispatch({
        type: types.SET_QUANTITY,
        payload: value
    });
}

export const setSize = (value) => dispatch => {
    dispatch({
        type: types.SET_SIZE,
        payload: value
    });
}

export const setLogo = (value) => dispatch => {
    dispatch({
        type: types.SET_LOGO,
        payload: value
    });
}

export const resetState = () => (dispatch) => {
    dispatch({
        type: types.RESET_STATE,
        payload: null,
    })
}

export const createNewPerson = (apparelItem, sizes, logosJson, department) => {
    let personObject = {
        name: '',
        quantities: [],
    }

    if (department.is_for_manager) {
        personObject.middleName = '';
        personObject.lastName = '';
        personObject.uthId = '';
        personObject.shirts = 0;
    }

    for (let i = 0; i < sizes.length; i++) {
        personObject.quantities.push(0);
    }

    if (logosJson.length > 0) {
        personObject.logo = '';
        personObject.isUthHouston = 0;
    }

    if (!empty(apparelItem.logos_options_json)) {
        let hasUtp = false;
        const logos = JSON.parse(apparelItem.logos_options_json);
        for (let i = 0; i < logos.length; i++) {
            if (parseInt(logos[i].value) === 1) {
                hasUtp = true;
                break;
            }
        }

        if (!hasUtp) {
            personObject.logo = '';
            personObject.isUthHouston = 1;
        }
    }

    if (apparelItem != null && apparelItem.allow_personalization) {
        personObject.embroideryFirstLine = '';
        personObject.embroiderySecondLine = '';
        personObject.embroideryEmail = '';
    }

    return personObject;
}

export const fetchDepartment = (id) => (dispatch) => {
    dispatch({ type: types.FETCH_DEPARTMENT, payload: null });
    axios.get(apiUrl + '/uthealth-departments/' + id,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.FETCH_DEPARTMENT_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            dispatch({ type: types.FETCH_DEPARTMENT_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const addPerson = (sizes, logosJson) => (dispatch, getState) => {
    const apparelItem = selectors.getApparelItem(getState());
    const department = selectors.getDepartment(getState());
    dispatch({
        type: types.ADD_PERSON,
        payload: createNewPerson(apparelItem, sizes, logosJson, department),
    });
}

export const removePerson = (index) => (dispatch) => {
    dispatch({
        type: types.REMOVE_PERSON,
        payload: index,
    });
}

export const setPersonField = (personIndex, fieldIndex, value) => (dispatch) => {
    dispatch({
        type: types.SET_PERSON_FIELD,
        payload: { personIndex, fieldIndex, value },
    });
}

export const setPersonQuantity = (personIndex, quantityIndex, value) => (dispatch) => {
    let validValue = parseInt(value);
    if (validValue < 0) {
        validValue = 0;
    }

    dispatch({
        type: types.SET_PERSON_QUANTITY,
        payload: { personIndex, quantityIndex, value: validValue },
    });
}

export const initPersons = (sizes, logosJson, department) => (dispatch, getState) => {
    const apparelItem = selectors.getApparelItem(getState());
    dispatch({
        type: types.INIT_PERSONS,
        payload: createNewPerson(apparelItem, sizes, logosJson, department),
    });
}

export const setManagerClinicName = (value) => dispatch => {
    dispatch({
        type: types.SET_MANAGER_CLINIC_NAME,
        payload: value
    });
}
export const setManagerName = (value) => dispatch => {
    dispatch({
        type: types.SET_MANAGER_NAME,
        payload: value
    });
}
export const setManagerEmail = (value) => dispatch => {
    dispatch({
        type: types.SET_MANAGER_EMAIL,
        payload: value
    });
}
export const setManagerAddress = (value) => dispatch => {
    dispatch({
        type: types.SET_MANAGER_ADDRESS,
        payload: value
    });
}
export const setManagerCity = (value) => dispatch => {
    dispatch({
        type: types.SET_MANAGER_CITY,
        payload: value
    });
}
export const setManagerState = (value) => dispatch => {
    dispatch({
        type: types.SET_MANAGER_STATE,
        payload: value
    });
}
export const setManagerZip = (value) => dispatch => {
    dispatch({
        type: types.SET_MANAGER_ZIP,
        payload: value
    });
}
export const setManagerPhone = (value) => dispatch => {
    dispatch({
        type: types.SET_MANAGER_PHONE,
        payload: value
    });
}
export const setPersonalizationEnabled = (value) => dispatch => {
    dispatch({
        type: types.SET_PERSONALIZATION_ENABLED,
        payload: value
    });
}
export const setApparelItem = (value) => dispatch => {
    dispatch({
        type: types.SET_APPAREL_ITEM,
        payload: value
    });
}
export const setDepartment = (value) => dispatch => {
    dispatch({
        type: types.SET_DEPARTMENT,
        payload: value
    });
}
export const setAction = (value) => (dispatch) => {
    dispatch({
        type: types.SET_ACTION,
        payload: value,
    })
}
export const setField = (field, value) => (dispatch) => {
    dispatch({
        type: types.SET_FIELD,
        payload: { field, value },
    })
}
export const addFile = (file) => (dispatch) => {
    dispatch({
        type: types.ADD_FILE,
        payload: file,
    });
}
export const removeFile = (index) => (dispatch) => {
    dispatch({
        type: types.REMOVE_FILE,
        payload: index,
    });
}
export const clearFiles = () => (dispatch) => {
    dispatch({
        type: types.CLEAR_FILES,
        payload: null,
    });
}